








import Popup from '@/views/organisms/Popup.vue'
import store from '@/store'
import BlueButton from '@/views/atoms/BlueButton.vue'

export default
  components: {
    Popup
    BlueButton
  }

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
  }
